import { DutyHourTypeWithDetails } from '../../types';

export const convertDataForBackend = (value: DutyHourTypeWithDetails) => ({
  ...value,
  reqDisconnectReasonAvId: Number.isInteger(value.reqDisconnectReasonAvId)
    ? value.reqDisconnectReasonAvId
    : undefined,
  dayCategory: undefined,
  dayCategorySvc: value.dayCategory?.code ?? ''
});
